'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosRedo = function IoIosRedo(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm5 31.3v-2.5c0-1.4-0.2-6.5 3.8-10.7 2.8-2.8 6.3-4.1 11.2-4.3v-6.3l15 10-15 10v-6.2c-3.1 0-4.9 0.7-6.8 1.5-2.4 1.1-4.3 3.5-5.9 6l-1.5 2.5h-0.8z' })
        )
    );
};

exports.default = IoIosRedo;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-redo.js
// module id = 2265
// module chunks = 0